
















































import { Component, Vue, Prop } from "vue-property-decorator";
import DetalheAtendimentoModel from "@/models/cadastros/saude/DetalheAtendimentoModel";

@Component
export default class DadosRemocao extends Vue {
  @Prop()
  detalhe!: DetalheAtendimentoModel;

  get enderecoOrigem(): string {
    if (this.detalhe.remocao?.origem) {
      const origem = this.detalhe.remocao?.origem;
      return `${origem.logradouro}, ${origem.numero}, ${
        origem.complemento ? origem.complemento + ", " : ""
      }${origem.bairro}, ${origem.cidade}-${origem.estado}`;
    }

    return "Endereço de origem não encontrado";
  }

  get enderecoDestino(): string {
    if (this.detalhe.remocao?.destino) {
      const destino = this.detalhe.remocao?.destino;
      return `${destino.logradouro}, ${destino.numero}, ${
        destino.complemento ? destino.complemento + ", " : ""
      }${destino.bairro}, ${destino.cidade}-${destino.estado}`;
    }

    return "Endereço de destino não encontrado";
  }

  get trajeto(): string {
    return this.detalhe.remocao?.trajeto || "";
  }
}
